$.eachComponent('.configurator-products-general', function(context) {

});